import { useEffect, useState } from "react";
import HomeLayout from "../layouts/HomeLayout";
import { deepMergeSiteDefaults, SITE_DEFAULTS } from "../utils/siteDefaults";

export default function HomePage() {
  const [data, setData] = useState(SITE_DEFAULTS);
  const [stableMenu, setStableMenu] = useState(SITE_DEFAULTS.stableMenu);
  const [gallery, setGallery] = useState({ enabled: true, images: [] });

  useEffect(() => {
    const siteUrl = `/content/site.json?v=${Date.now()}`;
    Promise.allSettled([
      fetch(siteUrl, { cache: "no-store" }).then((res) => (res.ok ? res.json() : Promise.reject())),
      fetch("/api/menu.php?action=list", { cache: "no-store" }).then((res) => (res.ok ? res.json() : Promise.reject())),
      fetch("/api/gallery.php?action=list", { cache: "no-store" }).then((res) => (res.ok ? res.json() : Promise.reject())),
    ]).then(([siteResult, menuResult, galleryResult]) => {
      const nextData =
        siteResult.status === "fulfilled" ? deepMergeSiteDefaults(siteResult.value) : SITE_DEFAULTS;
      setData(nextData);

      if (menuResult.status === "fulfilled" && menuResult.value?.ok) {
        setStableMenu({
          enabled: Boolean(menuResult.value.enabled),
          currentPdf: typeof menuResult.value.current === "string" ? menuResult.value.current : "",
        });
      } else {
        setStableMenu(nextData.stableMenu || SITE_DEFAULTS.stableMenu);
      }

      if (galleryResult.status === "fulfilled" && galleryResult.value?.ok) {
        setGallery({
          enabled: Boolean(galleryResult.value.enabled),
          images: Array.isArray(galleryResult.value.images) ? galleryResult.value.images : [],
        });
      } else {
        setGallery({ enabled: true, images: [] });
      }
    });
  }, []);

  const enabled = Boolean(data?.alert?.enabled);
  const alertText = enabled && data?.alert?.text?.trim() ? data.alert.text.trim() : "";

  return (
    <HomeLayout
      alertText={alertText}
      contact={data.contact}
      aboutText={data.aboutText}
      dailyMenu={data.dailyMenu}
      stableMenu={stableMenu}
      gallery={gallery}
    />
  );
}
